import { DateTime } from "luxon";
import { useMemo, useState } from "react";

export function lang(key) {
  if (window?.bf_globals?.language && !!key) {
    if (!!window?.bf_globals?.language[key]) {
      return window?.bf_globals?.language[key];
    } else if (!!window?.bf_globals?.language[key.toString().toLowerCase()]) {
      return window?.bf_globals?.language[key.toLowerCase()];
    }
  }
  return key;
}

export function currency(value, currency) {
  return new Intl.NumberFormat([], {
    style: 'currency',
    currency: currency || 'EUR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value || 0)
}

export function formatDate(date) {
  return DateTime
    .fromISO(date)
    .toLocaleString({ ...DateTime.DATE_SHORT, day: '2-digit', month: '2-digit' });
}

export function percentage(value) {
  return (!!value) ? value + ' %' : ''
}

export function getDescendantProp(obj, path) {
  return path.split('.').reduce((acc, part) => acc && acc[part], obj)
}

export function useBfGlobals() {
  const [globals, setGlobals] = useState();
  const get = (field) => {
    const value = getDescendantProp(globals, field);
    return (!!value) ? value : '';
  }

  useMemo(() => {
    setGlobals(window.bf_globals)
  }, [window.bf_globals]);

  return { get: get };
}

export function useQuery() {
  const { search } = window.location;
  return useMemo(() => new URLSearchParams(search), [search]);
}

export function useUrl(url) {

  const [href, setHref] = useState(null);

  useMemo(() => {
    setHref((!!url) ? url : window.location.href);
  }, [url, window.location.href]);

  return href;
}

export function downloadFile(data) {
  const linkSource = `data:${data.mimetype};base64,${data.data}`;
  const downloadLink = window.document.createElement("a");
  downloadLink.href = linkSource;
  downloadLink.download = data.fileName;
  downloadLink.click();
}

export function downloadAttachment(data) {
  const linkSource = `data:${data.mimeType};base64,${data.value}`;
  const downloadLink = window.document.createElement("a");
  downloadLink.href = linkSource;
  downloadLink.download = data.fileName;
  downloadLink.click();
}

export function downloadBlob(blob, filename) {
  let objectURL = URL.createObjectURL(blob);
  let a = document.createElement('a');
  a.href = objectURL;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
}